import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MainLayout from '../../layouts/MainLayout';

import DictaBookShelf from './DictaBookShelf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookAtlas, faFaceSmileBeam } from '@fortawesome/free-solid-svg-icons';
import dictabookimage from '../../assets/pageimages/DictaBook.webp';
import './DictaBook.css';

function DictaBookHome() {
    const authState = useSelector(state => state.authReducer);
    const userName = authState.user.name;

    return (
        <MainLayout>
        <div className="mt-12 bg-gradient-to-r from-purple-700 via-blue-700 to-indigo-700 min-h-screen p-4 sm:p-8">
            <div className="flex justify-center mt-8 sm:mt-12 relative">
                <img
                    id="dictabook-id"
                    src={dictabookimage}
                    alt="My Dicta Book Image"
                    className="shadow-xl border border-gray-400 rounded-lg max-w-full sm:w-1/2 md:w-1/3"
                />
                <h1 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-lg sm:text-2xl md:text-3xl font-semibold text-center">
                    Dictation Made Fun <br /> with Think5Whys
                </h1>
            </div>

            <div className="mt-8 sm:mt-12 flex justify-center">
                <Link 
                    to='/dicta-features' 
                    className='flex items-center justify-center w-full sm:w-2/3 md:w-1/2 h-12 sm:h-16 text-lg sm:text-2xl font-bold text-white bg-yellow-500 rounded-lg shadow-lg transition-transform hover:scale-105 focus:outline-none focus:ring focus:ring-yellow-400'
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4" icon={faFaceSmileBeam} />  
                    Explore DictaBook Features
                </Link>
            </div>

             <div className="flex justify-center mt-8">
                <Link 
                    to='/dashboard' 
                    className='flex items-center justify-center w-4/5 sm:w-2/4 h-12 sm:h-16 text-lg sm:text-2xl font-semibold text-white bg-blue-600 rounded-lg shadow-lg transition-transform hover:scale-105 focus:outline-none focus:ring focus:ring-blue-500'
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4" icon={faBookAtlas} />  
                    Go to Dashboard
                </Link>
            </div>

            <div className="mt-8 sm:mt-12 px-2">
                <div className="bg-white p-4 rounded-lg shadow-xl">
                    <DictaBookShelf />
                </div>
            </div>
        </div>
    </MainLayout>
    );
}

export default DictaBookHome;
